/**
 * Snowplow tracker namespace.
 *
 * Lives in a constants-only module (no SDK imports) so consumers that need only
 * the namespace literal — e.g. the install-source analytics orchestrator — can
 * import it without transitively pulling `@snowplow/browser-tracker` into their
 * module graph. That keeps the SDK off the on-prem bundle's load path per the
 * F1 guardrail (`.ai-context/onprem-guardrails.md`).
 */
export const SNOWPLOW_TRACKER_NAMESPACE = 'heidi';
